export const constant = {
    product: "product",
    groupName: "groupName",
    username: "username",
}